import { Point } from '../../type/common.interface';

// 计算两点之间比例位置的点
export function getPointBetween(point1: Point, point2: Point, ratio: number): Point {
    const x = point1.x + (ratio * (point2.x - point1.x));
    const y = point1.y + (ratio * (point2.y - point1.y));
    return { x, y };
}
